import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, LoveFluteStory, CraftSection, WatchListen } from "@/sections";

export default function StoryPage() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/site-content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="The Story"
        title="The story of the love flute"
        subtitle="An old Native American legend, the craft of Auburn Druid, and the voice of every instrument that leaves the Waitetuna workshop."
      />
      <LoveFluteStory />
      <CraftSection content={content} />
      <WatchListen />
      <Footer content={content || {}} />
    </div>
  );
}
